<template>
  <div :class="[bemClass(), $attrs.class, isCheckedClass]" :style="$attrs.style">
    <input
      type="radio"
      :id="radioId"
      :name="name"
      :value="value"
      :checked="checked"
      @input="input"
      v-bind="attrs"
      :class="bemClass('input')">
    <label :for="radioId" :class="bemClass('label')">
      <slot></slot>
    </label>
  </div>
</template>

<script>
import { computed, toRefs } from 'vue'
import useBem from '../../compositions/bem'
import useAttrs from '../../compositions/use-attrs'
import { selGenUniqueId } from '../../util/util'

export default {
  name: 'SelRadio',
  inheritAttrs: false,
  props: {
    modelValue: {
      type: [String, Number],
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    value: {
      type: [String, Number],
      default: ''
    },
    // TODO: Working on this option
    showRadio: {
      type: Boolean,
      default: true
    },
    modifier: {
      type: String,
      default: ''
    }
  },
  setup (props, { emit }) {
    const { modifier } = toRefs(props)
    const attrs = useAttrs()
    const { bemClass } = useBem('sel-radio', modifier)

    const radioId = `radio-${selGenUniqueId()}`
    const checked = computed(() => {
      return !isNaN(props.value)
        ? parseInt(props.modelValue) === parseInt(props.value)
        : props.modelValue === props.value
    })
    const isCheckedClass = computed(() => checked.value ? 'is-checked' : '')

    function input ($event) {
      emit('update:modelValue', $event.target.value)
    }

    return {
      bemClass,
      attrs,
      checked,
      isCheckedClass,
      input,
      radioId
    }
  }
}
</script>
